"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";

export default function ForTeachers() {
  return (
    <section id="teachers" className="relative overflow-hidden bg-muted py-16 px-4">

      <div className="container mx-auto relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
          {/* Left: photo */}
          <motion.div
            className="flex-1 flex justify-center md:justify-start order-1"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.55, delay: 0.1, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            <div className="relative w-full max-w-md">
              <Image
                src="/images/landing/teachers-photo.jpg"
                alt="Teachers and volunteers"
                width={520}
                height={380}
                className="rounded-2xl object-cover w-full shadow-lg"
              />
              {/* 8-point star */}
              <svg
                aria-hidden="true"
                viewBox="0 0 100 100"
                className="absolute -top-6 -left-6 w-16 h-16 md:w-20 md:h-20 drop-shadow-md"
              >
                <polygon
                  points="50,0 57.65,31.52 85.36,14.64 68.48,42.35 100,50 68.48,57.65 85.36,85.36 57.65,68.48 50,100 42.35,68.48 14.64,85.36 31.52,57.65 0,50 31.52,42.35 14.64,14.64 42.35,31.52"
                  fill="var(--primary)"
                  stroke="var(--primary)"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </motion.div>

          {/* Right: text */}
          <motion.div
            className="flex-1 text-center md:text-left order-2"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              For teachers and volunteers
            </h2>
            <p className="text-foreground/80 text-base leading-relaxed">
              Support youth through a practical and engaging financial learning journey. Teachers and
              volunteers can access the platform to follow learner progress, support engagement, and
              help connect learning to real-life conversations and experiences.
            </p>
            <motion.div
              className="flex gap-4 flex-wrap mt-6 justify-center md:justify-start"
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.4, delay: 0.2 }}
            >
              <Link
                href="/teacher/register"
                className="border border-secondary text-foreground bg-transparent hover:bg-secondary/15 rounded-full px-6 py-2 text-sm font-medium hover:scale-105 hover:-translate-y-0.5 active:scale-95 transition-all duration-150"
              >
                Teacher / Volunteer Log In
              </Link>
              <Link
                href="#who"
                className="border border-secondary text-foreground bg-transparent hover:bg-secondary/15 rounded-full px-6 py-2 text-sm font-medium hover:scale-105 hover:-translate-y-0.5 active:scale-95 transition-all duration-150"
              >
                Learn more
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
